const isDevelopment = location.hostname === 'localhost';

const adminServer = isDevelopment ? "http://localhost:3000" : "https://admin.instapaylink.com";

const s3Bucket = isDevelopment ?
    "https://instapaylink-sellers-dev.s3.amazonaws.com" :
    "https://instapaylink-sellers.s3.amazonaws.com";

export {adminServer, s3Bucket};
